// 案件詳情頁面翻譯（畫布列表）
export default {
  // 頁面標題
  pageTitle: "案件詳情",

  // 頂部操作按鈕
  buttons: {
    edit: "編輯",
    delete: "刪除",
  },

  // 標籤頁
  tabs: {
    canvasAnalysis: "畫布分析",
    dataBoard: "數據看板",
    surveyManage: "調證建議",
    surveyUser: "調證用戶",
    addressMonitor: "地址監控",
    keyAddress: "關鍵地址",
    characterInfo: "人物信息",
    remarkManagement: "備註管理",
  },

  // 確認對話框
  confirmDialog: {
    deleteTitle: "提示",
    deleteMessage: "此操作將永久刪除{caseName}畫布, 是否確定?",
    confirmButton: "確定",
    cancelButton: "取消",
  },

  // 消息提示
  messages: {
    deleteSuccess: "刪除成功",
    deleteCancelled: "已取消刪除",
  },
};
